// Builds the "View Invoices" target URL (D4, §5.8) from the current drill scope.
// Carries exactly the scope params for the current position — never a stale
// deeper key left over from a scope the user drilled back up out of.
//
// Product scope uses the canonical `productId` (Stage 1 UI upgrade §8.3/§8.5):
// the product code is display text returned by data, never an independently
// trusted filter parameter.
export const buildInvoiceDashboardUrl = ({
  manufacturerId,
  categoryId,
  groupId,
  productId,
  accountId,
  stateId,
  distributorId,
  startDate,
  endDate,
  // Executive Dashboard additions (Phase 2 section 5). All optional; absent
  // keys leave the URL exactly as before.
  regionId,
  status,
  completion,
  population,
  agingBucket,
  from,
}) => {
  const params = new URLSearchParams();
  if (manufacturerId !== undefined && manufacturerId !== null) {
    params.set("manufacturerId", String(manufacturerId));
  }
  if (categoryId !== undefined && categoryId !== null) {
    params.set("categoryId", String(categoryId));
  }
  if (groupId !== undefined && groupId !== null) {
    params.set("productGroupId", String(groupId));
  }
  if (productId !== undefined && productId !== null) {
    params.set("productId", String(productId));
  }
  if (accountId !== undefined && accountId !== null) {
    params.set("accountId", String(accountId));
  }
  if (stateId !== undefined && stateId !== null) {
    params.set("stateId", String(stateId));
  }
  if (distributorId !== undefined && distributorId !== null) {
    params.set("distributorId", String(distributorId));
  }
  if (startDate) params.set("startDate", startDate);
  if (endDate) params.set("endDate", endDate);
  if (regionId !== undefined && regionId !== null) {
    params.set("regionId", String(regionId));
  }
  if (status) params.set("status", status);
  if (completion) params.set("completion", completion);
  if (population) params.set("population", population);
  if (agingBucket) params.set("agingBucket", agingBucket);
  if (from) params.set("from", from);

  return `/InvoiceDashboard?${params.toString()}`;
};

// Top-account rows link straight to the account, no filter carry-over (D4).
export const buildAccountUrl = (accountId) => `/Account/${accountId}`;
